<template>
    <div class="modal-card upload-model">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                <span v-if="noTextMessage">
                    {{ noTextMessage }}
                </span>
                <span v-else-if="sendMail">
                    Solicitar el archivo<br />
                    <span class="file_to_show">{{ filesToShow.desc }}</span><br />
                    al usuario
                </span>
                <span v-else class="has-text-weight-bold">
                    Seleccione un usuario a reemplazar<br />
                    para subir un archivo:
                </span>
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section style="background:#F8F9FD;" class="">
            <div style="background:#F8F9FD;" role="navigation" aria-label="main navigation" class="user_list">
                <div class="">
                    <a class="mr-3 mb-3 button is-rounded" :class="{
                    'has-background-info-dark': selectedUserId == user.user_id,
                    'has-background-info-light': selectedUserId != user.user_id,
                    'has-text-white': selectedUserId == user.user_id,
                    'has-text-black': selectedUserId != user.user_id
                }" @click="() => { selectedUserId = user.user_id }" v-for="user in selectedFilesByUser"
                        v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>
            </div>
            <div class="dashboard_mail" v-if="sendMail">
                <div class="container_mail">
                    <span v-if="noTextMessage">
                        (Este botón enviará el correo a las direcciones seleccionadas).
                    </span>
                    <textarea v-else v-model="message" rows="5" cols="44"></textarea>
                    <br />
                    <div class="button-and-warning-container">
                        <b-button class="enviar_correo" type="is-secondary"
                            :disabled="selectedUserId == -1 || sendingProcess" @click="actuallySendMail()">
                            Enviar correo
                        </b-button>
                        <div>{{ warning }}</div>
                    </div>
                </div>
            </div>
            <div class="dashboardfileupload" v-else>
                <DashboardFileUpload :fileId="fileId" :hideHistoricBtn="true" :userIdSuplanted="selectedUserId"
                    :filesByUser="fileByUser" :disableUploadBtn="selectedUserId == -1">
                </DashboardFileUpload>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
        </footer>
    </div>
</template>

<script>
import { sendEmailDocs } from "@/api/carteraAnalista";
import DashboardFileUpload from "@/views/DashboardFileUpload";

export default {
    name: "UploadFileAsUserModal",
    data() {
        return {
            sendingProcess: false,
            loading: false,
            fileByUser: [],
            selectedUserId: -1,
            filesToShow: [],
            message: "Por favor envienos el archivo ",
            warning: "",
        };
    },
    components: {
        DashboardFileUpload
    },
    methods: {
        async actuallySendMail() {
            this.sendingProcess = true;
            try {
                const result = sendEmailDocs(this.idCompany, this.selectedUserId, this.which);
                const result_result = await result;
                if (result_result.status == 200) {
                    this.warning = result_result.data['message'];
                } else {
                    this.warning = 'Error al enviar el correo.';
                }
            } catch (err) {
                this.warning = 'Error al enviar correo.';
            }
            this.sendingProcess = false;
        },
    },
    props: ["fileId", "idCompany", "selectedFilesByUser", "sendMail", "noTextMessage", "which"],
    created() {
        this.fileByUser = this.selectedFilesByUser[0].files
        if (!this.noTextMessage) {
            const firstFiles = this.selectedFilesByUser[0].files;
            this.filesToShow = firstFiles.filter(file => file.id == this.fileId)[0];
            const date = new Date();
            const month = date.toLocaleString('es', { month: 'long' });
            this.message += this.filesToShow.desc + " del mes de " + month + ".";
        }
        this.warning = "(Debe seleccionar un usuario)"
    },
    watch: {
        selectedUserId: function (val) {
            if (val) {
                this.warning = "";
            }
        }
    }
};
</script>
<style scoped>
.upload-model {
    width: 900px;
}

.dashboardfileupload {
    margin-left: 50px;
    margin-right: 50px;
}

.user_list {
    padding-top: 10px;
    padding-left: 30px;
}

.file_to_show {
    font-weight: 600;
    font-size: 110%;
}

.dashboard_mail {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
}

.container_mail {
    padding: 3%;
    margin-bottom: 10px;
    background-color: #f0f0ff;
    border-radius: 10px;
    width: 490px;
    position: relative;
    left: -12px;
}

.enviar_correo {
    margin: 5px 0px 0px 2px;
    font-weight: 600;
}

.enviar_correo:disabled {
    background-color: #9090b0;
    color: transparent;
    text-shadow: 0 0 3px #ccc;
    font-weight: 600;
}

.button-and-warning-container {
    display: flex;
    align-items: center;
    justify-content: start;
}

.button-and-warning-container .enviar_correo {
    margin-right: 10px;
}
</style>